/**
 * Created by xnr on 19/12/30.
 */

export function isvalidUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/* 邮箱校验*/
export function validateeMail(str) {
  const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  return reg.test(str);
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
var isMob = /^((\+?86)|(\(\+86\)))?(1[0-9]{10})$/;
var phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

// 电话号码校验
export function validateTelephone(rule, value, callback) {
  if (!isMob.test(value) && !isPhone.test(value)) {
    callback(new Error("请输入符合规范的电话号码"));
  } else {
    callback();
  }
}

// 手机号码校验
export function validateMobilePhone(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    if (!isMob.test(value)) {
      callback(new Error("请输入正确的手机号码"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

export function phone(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入手机号"));
  } else if (!phoneReg.test(value)) {
    callback(new Error("请正确输入手机号"));
  } else {
    callback();
  }
}

// 验证码校验
export function validateCode(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    var isCode = /^[0-9]{6}$/;
    if (!isCode.test(value)) {
      callback(new Error("请输入6位数字"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 密码校验
var pattern = /^[0-9]{6}$/; ///(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,20}$/
export function validatePass(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else if (!pattern.test(value)) {
    callback(new Error("长度为6位数字"));
  } else {
    callback();
  }
}

// 校验小数后2位
export function floatValidate(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    var pattern = /^([0-9]\d?(\.\d{1,2})?|100)$/;
    if (!pattern.test(value)) {
      callback(new Error("请输入保留100以内的小数点后2位数字"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 校验单价，精确到小数点后2位
export function unitPriceValidate(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    var pattern = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
    if (!pattern.test(value)) {
      callback(new Error("请输入整数或者保留两位小数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 校验总价，精确到小数点后5位
export function totalPriceValidate(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    var pattern = /(^[1-9]\d*(\.\d{1,5})?$)|(^0(\.\d{1,5})?$)/;
    if (!pattern.test(value)) {
      callback(new Error("请输入整数或者保留五位小数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 校验单重，精确到小数点后2位
export function unitWeightValidate(rule, value, callback) {
  if (rule.required || (value && value !== "")) {
    var pattern = /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/;
    console.log("pattern=" + pattern);
    console.log("value=" + value);
    if (!pattern.test(value)) {
      callback(new Error("请输入整数或者保留两位小数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 正数校验
export function positiveNumValidate(rule, value, callback) {
  var pattern = /^(\+)?\d+(\.\d+)?$/;
  if (rule.required || (value && value !== "")) {
    if (!pattern.test(value)) {
      callback(new Error("请输入正数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 整数校验
export function integerNumValidate(rule, value, callback) {
  var pattern = /^(\+)?\d+$/;
  if (rule.required || (value && value !== "")) {
    if (!pattern.test(value)) {
      callback(new Error("请输入正整数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

const format = {
  Date(timestamp, formats) {
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    formats = formats || "Y-m-d";
    var zero = function(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    };
    if (typeof timestamp == typeof "") {
      timestamp = timestamp.replace(/-/g, "/").replace(/\.0/g, "");
    }
    var myDate = timestamp ? new Date(timestamp) : new Date();
    var year = myDate.getFullYear();
    var month = zero(myDate.getMonth() + 1);
    var day = zero(myDate.getDate());
    var hour = zero(myDate.getHours());
    var minite = zero(myDate.getMinutes());
    var second = zero(myDate.getSeconds());
    return formats.replace(/Y|m|d|H|i|s/gi, function(matches) {
      return {
        Y: year,
        m: month,
        d: day,
        H: hour,
        i: minite,
        s: second
      }[matches];
    });
  }
};

// 身份证
var identityCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

export function identityCard(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入身份证"));
  } else if (!identityCardReg.test(value)) {
    callback(new Error("请正确输入身份证"));
  } else {
    callback();
  }
}

// 仅支持数字，小数点后一位小数点前三位
var awardMoneyReg = /^[0-9]{1,3}(\.[0-9])?$/;

export function awardMoney(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入金额"));
  } else if (!awardMoneyReg.test(value)) {
    callback(new Error("仅支持数字，支持小数点后一位，金额不超过三位数"));
  } else {
    callback();
  }
}

// 分润比例---1到100之间整数
var regionRatioReg = /^\d*$/;

export function regionRatio(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入比例"));
  } else if (!regionRatioReg.test(value) || value < 1 || value > 100) {
    callback(new Error("仅支持1到100之间的整数"));
  } else {
    callback();
  }
}

// 考核指标 0-9999.9之间的数字
var assessTopReg = /^\d{0,4}(\.\d)?$/;

export function assessTo(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入金额"));
  } else if (
    !assessTopReg.test(value) ||
    parseFloat(value) < 0 ||
    parseFloat(value) > 9999.9
  ) {
    callback(new Error("仅支持0-9999.9之间的数字，小数点后仅支持1位"));
  } else {
    callback();
  }
}

// 考核周期 1-365之间的整数
var assessPeriodReg = /^\d*$/;

export function assessPeriod(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入"));
  } else if (!assessPeriodReg.test(value) || value < 1 || value > 365) {
    callback(new Error("仅支持1到365之间的整数"));
  } else {
    callback();
  }
}

// 连续未达标次数 1-99之间的整数
var notAssessReg = /^\d*$/;

export function notAssess(rule, value, callback) {
  if (rule.required == true) {
    if (value === "") {
      callback(new Error("请输入"));
    } else if (!notAssessReg.test(value) || value < 1 || value > 99) {
      callback(new Error("仅支持1到99之间的整数"));
    } else {
      callback();
    }
  } else if (value && (!notAssessReg.test(value) || value < 1 || value > 99)) {
    callback(new Error("仅支持1到99之间的整数"));
  } else {
    callback();
  }
}

export { format };
